import {IComponentController} from 'angular';
import {IMonoOccurrence, IMonoOccurrenceOptions} from '../../../../../core/services/mono-occurrence.service';
import {IMultiOccurrenceOptions} from '../../../../../core/services/multi-occurrence.service';
import {IFormulaire,IFormulaireClass} from '../../../../../core/services/formulaire/formulaire.service';
import {IFormulaireItemClass} from '../../../../../core/services/formulaire/formulaire-item.service';
import {IFormulaireItemSautDeLigneClass} from '../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service';
import {IFormulaireGroupeAccordeonClass} from '../../../../../core/services/formulaire/formulaire-groupe-accordeon.service';
import {IFormulaireItemSautDeColonneClass} from '../../../../../core/services/formulaire/formulaire-item-saut-de-colonne.service';
import {IFormulaireGroupeClass} from '../../../../../core/services/formulaire/formulaire-groupe.service';

interface IPageMR0327 extends IComponentController {
    valeursEcran: any;
    formulairePfp: IFormulaire;
    monoOccurrence: IMonoOccurrence;
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    ppbMultiOccurrenceOptions: IMultiOccurrenceOptions;
    pfsMultiOccurrenceOptions: IMultiOccurrenceOptions;
    pfpMultiOccurrenceOptions: IMultiOccurrenceOptions;
}

interface IMr0327Params {
    province: string;
    pafcleint: number;
}

/* @ngInject */
export default function Mr0327Controller($stateParams: IMr0327Params,
                                         Formulaire: IFormulaireClass,
                                         FormulaireItem: IFormulaireItemClass,
                                         FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass,
                                         FormulaireItemSautDeColonne: IFormulaireItemSautDeColonneClass,
                                         FormulaireGroupe: IFormulaireGroupeClass,
                                         FormulaireGroupeAccordeon: IFormulaireGroupeAccordeonClass) {
    const vm: IPageMR0327 = this;

    vm.$onInit = $onInit;

    function $onInit() {
        vm.formulairePfp = new Formulaire('LBL_BLC_PFP', [
            new FormulaireItem('vaesyscodprv', { default: $stateParams.province }),
            new FormulaireItem('pfptd1mntbas', { largeur: 10 }),
            new FormulaireItem('pfpimftaut3', { largeur: 10 }),
            new FormulaireItem('pafcleint', { default: $stateParams.pafcleint }),
            new FormulaireItemSautDeLigne(),
            new FormulaireGroupeAccordeon('LBL_ASSURANCE_EMP',
                new Formulaire([
                    new FormulaireItem('pfpasemga'),
                    new FormulaireItem('pfpasetau'),
                    new FormulaireItem('pfpasefctemrreg'),
                    new FormulaireItem('pfpasefctemrred')
                ], { largeurDefaut: 25 }), { largeur: 100 }
            ),
            new FormulaireItemSautDeLigne(),
            new FormulaireGroupeAccordeon('LBL_CSSIAT',
                new Formulaire([
                    new FormulaireItem('pfpcssmga')
                ]), { largeur: 50 }
            ),
            new FormulaireGroupeAccordeon('LBL_GRATIFIC',
                new Formulaire([
                    new FormulaireItem('pfpgrarevmin'),
                    new FormulaireItem('pfpgrataumin')
                ]), { largeur: 50 }
            ),
            new FormulaireItemSautDeLigne(),
            new FormulaireGroupeAccordeon('LBL_PARAM',
                new Formulaire([
                    new FormulaireGroupe('LBL_S',
                        new Formulaire([
                            // LIGNE 1
                            new FormulaireItem('pbcmnt001s', { titre: ' ', minWidth: 180, libellesContour: { gauche: 'LBL_T4G' } }),
                            new FormulaireItemSautDeColonne({ largeur: 40 }),
                            new FormulaireItem('pbcmnt002s', { titre: ' ', minWidth: 180,
                                libellesContour: {
                                    gauche: {
                                        largeur: 55,
                                        texte: 'LBL_A1INFEGA_G',
                                        alignment: 'left'
                                    }
                                }
                            }),
                            new FormulaireItemSautDeColonne(),
                            new FormulaireItemSautDeLigne(),
                            // LIGNE 2
                            new FormulaireItem('t_pbcmnt001s', { titre: ' ', minWidth: 180, libellesContour: { gauche: 'LBL_T4G' },
                                default: () => vm.monoOccurrence.data.pbcmnt001s
                            }),
                            new FormulaireItem('t_pbcmnt002s', { titre: ' ', minWidth: 180, libellesContour: { gauche: 'LBL_A1MOINS_G', droite: 'LBL_A1PARFER_D' },
                                default: () => vm.monoOccurrence.data.pbcmnt002s
                            }),
                            new FormulaireItem('pbcprc001s', { titre: ' ', minWidth: 180, libellesContour: { droite: 'LBL_A1CROFER_D' } }),
                            new FormulaireItem('t_pbcmnt002s', { titre: ' ', minWidth: 180,
                                libellesContour: {
                                    gauche: {
                                        largeur: 55,
                                        texte: 'LBL_A1SUP_G',
                                        alignment: 'left'
                                    }
                                },
                                default: () => vm.monoOccurrence.data.pbcmnt002s
                            }),
                            new FormulaireItem('pbcmnt003s', { titre: ' ', minWidth: 180, libellesContour: { gauche: 'LBL_INFEGA_G' } }),
                            new FormulaireItemSautDeLigne(),
                            // LIGNE 3
                            new FormulaireItem('pbcmnt004s', { titre: ' ', minWidth: 180, libellesContour: { gauche: { largeur: 35, texte: ' ' } } }),
                            new FormulaireItemSautDeColonne({ largeur: 40 }),
                            new FormulaireItem('t_pbcmnt003s', { titre: ' ', minWidth: 180,
                                libellesContour: {
                                    gauche: {
                                        largeur: 55,
                                        texte: 'LBL_A1SUP_G',
                                        alignment: 'left'
                                    }
                                },
                                default: () => vm.monoOccurrence.data.pbcmnt003s
                            }),
                            new FormulaireItemSautDeColonne()
                        ], { largeurDefaut: 20 }), { largeur: 100 }
                    ),
                    new FormulaireGroupe('LBL_LCP',
                        new Formulaire([
                            new FormulaireItem('pbclimlcp'),
                            new FormulaireItem('pbcprclcp', { libellesContour: { gauche: 'LBL_OU' } })
                        ], { largeurDefaut: 5 }), { largeur: 50 }
                    )
                ]), { largeur: 100 }
            )
        ], { largeurDefaut: 25 });

        // Borne
        vm.ppbMultiOccurrenceOptions = {
            bloc: 'ppb',
            colonnesVisibles: [
                {nom: 'ppbborinf', largeur: 120},
                {nom: 'ppbtau'   , largeur: 85},
                {nom: 'ppbval'   , largeur: 120}
            ],
            formulaire: new Formulaire([
                new FormulaireItem('ppbborinf'),
                new FormulaireItem('ppbtau'),
                new FormulaireItem('ppbval')
            ], { largeurDefaut: 33.33 })
        };

        // Taux AE réduit
        vm.pfsMultiOccurrenceOptions = {
            bloc: 'pfs',
            colonnesVisibles: [
                {nom: 'rfecod'      , largeur: 150},
                {nom: 'rfenomabr'   , largeur: 241},
                {nom: 'pfsfctemrred', largeur: 135},
                {nom: 'pfsflg512'   , largeur: 105},
                {nom: 'bqecod'      , largeur: 89},
                {nom: 'bqedscabr'   , largeur: 262}
            ],
            formulaire: new Formulaire([
                new FormulaireItem('rfecleint', { largeur: 50 }),
                new FormulaireItem('pfsfctemrred'),
                new FormulaireItem('pfsflg512'),
                new FormulaireItem('bqecleint', { largeur: 50,
                    resourceParams: (data: any) => ({ pfsflg512: data.pfsflg512 })
                })
            ], { largeurDefaut: 25 })
        };
    }
}
